import { useRef, useEffect } from 'react';
import { Button } from '../components/Button.jsx';
import { PAGE } from '../state/pages.js';
import { COUNTRIES } from '../data/countries.js';

const PRIORITY_COUNTRY_CODES = new Set(['GB']);
const COUNTRIES_FOR_SELECT = [
  ...COUNTRIES.filter((country) => PRIORITY_COUNTRY_CODES.has(country.code)),
  ...COUNTRIES.filter((country) => !PRIORITY_COUNTRY_CODES.has(country.code))
];

export function CountryEntryPage({ playerCountry, onCountryChange, onNavigate }) {
  const selectRef = useRef(null);

  useEffect(() => {
    selectRef.current?.focus();
  }, []);

  function handleChange(e) {
    onCountryChange(e.target.value);
  }

  function handleContinue() {
    if (playerCountry) {
      onNavigate(PAGE.SETUP_ROLE);
    }
  }

  function handleBack() {
    onNavigate(PAGE.SETUP_NAME);
  }

  const isValid = playerCountry && playerCountry !== '';

  return (
    <main tabIndex={-1} className="onboarding-screen onboarding-country">
      <div className="onboarding-content">
        <h1 className="onboarding-title">Select your country</h1>

        <div className="onboarding-form">
          <select
            ref={selectRef}
            value={playerCountry}
            onChange={handleChange}
            className="onboarding-select"
            aria-label="Country selection"
          >
            <option value="" disabled>
              Choose your country...
            </option>
            {COUNTRIES_FOR_SELECT.map((country) => (
              <option key={country.code} value={country.code}>
                {country.name}
              </option>
            ))}
          </select>
        </div>

        <div className="onboarding-actions">
          <Button
            variant="ghost"
            onClick={handleBack}
            changesScreen
            testId="country-back"
            audioCue="buttonSecondary"
          >
            Back
          </Button>
          <Button
            onClick={handleContinue}
            changesScreen
            disabled={!isValid}
            testId="country-continue"
            audioCue="buttonSecondary"
          >
            Continue
          </Button>
        </div>
      </div>
    </main>
  );
}
